import React, { useState } from "react";
import styled from "styled-components";
import { company } from "../../config";
import Alien from "../../assets/alien.svg";
import Casual from "../../assets/casual.svg";
import Doubt from "../../assets/doubt.svg";
import Frown from "../../assets/frown.svg";
import Laugh from "../../assets/lol.svg";
import Master from "../../assets/master.svg";
import Refresh from "../../assets/icons/refresh.svg";
import ArrowDown from "../../assets/icons/down.svg";

const emotions = [
  {
    label: "My Casual Look",
    head: <Casual className="figure" />,
  },
  {
    label: "Another new bug",
    head: <Frown className="figure" />,
  },
  {
    label: "Eh ? Why the styling not work?",
    head: <Doubt className="figure" />,
  },
  {
    label: "Scrolling through MEME at Reddit",
    head: <Laugh className="figure" />,
  },
  {
    label: "Discover new programming language",
    head: <Master className="figure" />,
  },
  {
    label: "Reading some magic code",
    head: <Alien className="figure" />,
  },
];

const professionalLink =
  "https://medium.com/@danharris293/a-simple-guide-to-being-a-software-developer-2a2f0d6ce01d";

const StyledHeroSection = styled.section`
  background: var(--background);
  color: var(--black-dark);
`;

const StyledHeroBody = styled.div`
  grid-template-columns: 100%;

  @media (min-width: 1024px) {
    grid-template-columns: 50% 50% !important;
  }
  margin-bottom: var(--mb-4);
`;

const StyledHeroContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .subheading {
    font-family: var(--body-font-2);
    font-weight: var(--font-bold);
    color: var(--primary);
    font-size: var(--normal-large-font-size);
    margin-bottom: var(--mb-2);
  }

  .heading,
  .heading-2 {
    font-weight: var(--font-bold);
    font-size: var(--bigger-font-size);
    line-height: 1.1;
  }

  .heading-2 {
    color: var(--gray-dark);
    margin-bottom: var(--mb-4);
  }

  .description {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    max-width: 70vh;
    margin-bottom: var(--mb-2);
    line-height: 24px;
  }

  @media (min-width: 1024px) {
    align-items: flex-start;
    text-align: initial;
    justify-content: center;
  }
`;

const StyledHeroFigure = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  .figure {
    width: 250px;
    height: 100%;
  }

  .change-btn {
    display: flex;
    justify-content: center;
    cursor: pointer;
    width: var(--icon-btn-size);
    height: var(--icon-btn-size);
    outline: none;
    border: none;
    background: transparent;
    position: absolute;
    top: 10%;
    left: 90%;

    .refresh-icon {
      width: var(--icon-btn-size);
      height: var(--icon-btn-size);
      transition: transform 0.3s ease;
    }

    &:hover {
      .refresh-icon {
        fill: var(--gray-dark);
        transform: scale(1);
        transform: rotate(90deg);
      }
    }
  }

  .emotion {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    font-weight: var(--font-bold);
    word-wrap: break-word;
    height: 40px;
  }

  @media (min-width: 768px) {
    .figure {
      width: 350px;
      height: 100%;
    }
  }

  @media (min-width: 1024px) {
    .figure {
      width: 450px;
      height: 100%;
    }

    .change-btn {
      left: 80%;
    }
  }
`;

const StyledHeroBottom = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  .arrow-down-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }
`;

const StyledConnectWithMeContainer = styled.div`
  margin-top: var(--mb-5);
`;

const Hero = () => {
  const [index, setIndex] = useState(0);

  const _handleChangeFigure = () => {
    let currentIndex = index + 1;
    if (currentIndex >= emotions.length) {
      currentIndex = 0;
    }
    setIndex(currentIndex);
  };
  return (
    <StyledHeroSection
      className="section"
      id="hero-section"
      data-sal="slide-up"
      data-sal-delay="200"
      data-sal-easing="ease"
      data-sal-duration="1500"
    >
      <span id="hero" className="anchor"></span>
      <StyledHeroBody className="bd-grid">
        <StyledHeroContent>
          <p className="subheading">Hello World, I am</p>
          <h1 className="heading">Low Zi Jian.</h1>
          <p className="heading-2">I design & code for the web.</p>
          <p className="description">
            I'm a Malaysia-based{" "}
            <a className="highlighted-context" href={professionalLink}>
              Software Engineer
            </a>{" "}
            who specializes in designing and developing extraordinary websites.
            Currently, I'm a front-end web developer at{" "}
            <a className="highlighted-context" href={company}>
              Dasher
            </a>{" "}
            .
          </p>
          <StyledConnectWithMeContainer>
            <a className="contained-btn" href="/#contact">
              Connect with Me
            </a>
          </StyledConnectWithMeContainer>
        </StyledHeroContent>
        <StyledHeroFigure>
          {emotions[index].head}
          <p className="emotion">{`" ${emotions[index].label} "`}</p>
          <button className="change-btn" onClick={_handleChangeFigure}>
            <Refresh className="refresh-icon" />
          </button>
        </StyledHeroFigure>
      </StyledHeroBody>
      <StyledHeroBottom>
        <ArrowDown className="arrow-down-icon bounce" />
      </StyledHeroBottom>
    </StyledHeroSection>
  );
};

export default Hero;
